import { render, staticRenderFns } from "./waitSendScores.vue?vue&type=template&id=2b129598&scoped=true"
import script from "./waitSendScores.vue?vue&type=script&lang=js"
export * from "./waitSendScores.vue?vue&type=script&lang=js"
import style0 from "./waitSendScores.vue?vue&type=style&index=0&id=2b129598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b129598",
  null
  
)

export default component.exports